import { action, makeObservable, observable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export class ComplianceAssuranceStore {
  groupId: string = '';
  contractId: string = '';

  constructor() {
    makeObservable(this, {
      setGroupId: action,
      groupId: observable,
      setContractId: action,
      contractId: observable,
    });
    makePersistable(this, {
      name: 'ComplianceAssuranceStore',
      properties: ['groupId', 'contractId'],
      storage: window.localStorage,
    });
  }

  setGroupId(id: string) {
    this.groupId = id;
  }
  setContractId(id: string) {
    this.contractId = id;
  }
}

export default ComplianceAssuranceStore;
